import { useState, useEffect } from 'react';

function useInputModality() {
    const [isKeyboard, setIsKeyboard] = useState(false);
    useEffect(() => {
        const onKeyDown = (e) => {
            const keys = ["Tab"];
            if (keys.includes(e.key))
                setIsKeyboard(true);
        };
        const onPointer = () => setIsKeyboard(false);
        window.addEventListener("keydown", onKeyDown, true);
        window.addEventListener("mousedown", onPointer, true);
        window.addEventListener("touchstart", onPointer, true);
        return () => {
            window.removeEventListener("keydown", onKeyDown, true);
            window.removeEventListener("mousedown", onPointer, true);
            window.removeEventListener("touchstart", onPointer, true);
        };
    }, []);
    return isKeyboard;
}

export { useInputModality };
